import React from 'react';
import './mbko.css'
import img1 from '../style/list01.png'
import img2 from '../style/list02.png'
import img3 from '../style/list03.png'
import img4 from '../style/list04.png'
import img5 from '../style/list05.png'
import img6 from '../style/list06.png'
import img7 from '../style/list07.png'
import img8 from '../style/list08.png'
import img9 from '../style/list09.png'
import img10 from '../style/list10.png'
import img11 from '../style/list11.png'
import img12 from '../style/title_small.png'
import img13 from '../style/back-btn.png'
import { Link } from 'react-router-dom';
import img14 from '../style/AQU.png'
import { useEffect,useState } from 'react';
import Papa from 'papaparse' ;
import axios from 'axios';

import csvString from './data/바다동물장기.csv';


function AQU(props) {

    function convertCSVStringToList(csvString) {
        console.log(csvString)
        const { data } = Papa.parse(csvString);
        console.log(data)
        return data;
    }
    const [dataList,setDataList] = useState([]);


    useEffect(() => {
        window.scrollTo(0, 0); // 스크롤 위치를 (0, 0)으로 조정
        
        axios.get(csvString).then(res=>{
            setDataList(convertCSVStringToList(res.data));
        })

      }, []);
    
    return (
        <>
            <div className='bg-color'>
                <div className="background-image container container1">
                    <div className="AQU-image">
                         <div className='back-btn'>
                    <Link to="/mbko" style={{textDecoration:'none'}}>
                            {/* <img className='back-btn' src={img13}>

                            </img> */}
                        　　　　　　</Link>
                        </div>
                        <div className='game-top'>
                        <p style={{marginBottom:10}}>
                        <strong>종목: 바다동물장기 &#40;초등부&#41;</strong>
                        </p>

                        <p style={{marginBottom:0}}>
                            <strong>· 예선 안내</strong>
                            </p>
                        <p style={{marginBottom:0}}>
                            예선장소: 본 페이지 맨 아래 리스트 참고
                            </p>
                            <p style={{marginBottom:0}}>
                            참가비: 예선 개최지 문의
                            </p>
                            <p style={{marginBottom:0}}>
                            신청방법: 원하는 예선 개최지에 연락 또는 방문신청
                            </p>
                            <p style={{marginBottom:0}}>
                            예선시상: 1위 - 흔들어봐 엘프요정 / 2위 - 스피디롤 / &#40;사&#41;한국브레인스포츠연맹 상장 / 본선진출권
                            </p>
                            <p style={{marginBottom:30}}>
                            *본선진출권은 개최지마다 수량이 다릅니다. 정확한 순위는 개최지에 문의 부탁드립니다.
                            </p>

                        <p style={{marginBottom:0}}>
                            <strong>· 본선 안내</strong>
                            </p>
                        <p style={{marginBottom:0}}>
                            본선일시: 2023년 8월 19일 &#40;토&#41; 오전10시30분
                            </p>
                            <p style={{marginBottom:0}}>
                            본선장소: 수원컨벤션센터 1층 2대회장
                            </p>
                            <p style={{marginBottom:30}}>
                            진행방식: 3라운드 - 30분휴식 - 3라운드 &#40;총 6라운드&#41;
                            </p>



                        <p style={{marginBottom:0}}>
                        <strong>· 본선운영방식</strong>
                            </p>
                        <p style={{marginBottom:30}}>
                        　- 본 종목은 결승전 없이 모든 선수 6라운드 진행 후 &#40;사&#41;한국브레인스포츠연맹이 정한 승점 산정방식을 적용하여 순위를 정함
                        </p>

                        <p style={{marginBottom:10}}>
                            <strong>· 본선 시상 안내</strong>
                            </p>
                        <table className='table1'>
                                <tr>
                                    <th style={{width:"50px"}}>등수</th>
                                    <th className='th1'>시상내용</th>
                                </tr>                                
                                <tr>
                                    <td  className='td1'>1등</td>
                                    <td  className='td1'>보약게임 15만원 상품권, 우승 트로피, 상장, 메달</td>
                                </tr>
                                <tr>
                                    <td  className='td1'>2등</td>
                                    <td  className='td1'>아쿠아레나+탐정들 추리클럽+파이어퀘스트 각 1개, 상장, 메달</td>
                                </tr>
                                <tr>
                                    <td  className='td1'>3등</td>
                                    <td  className='td1'>탐정들 추리클럽+파이어퀘스트 각 1개, 상장, 메달</td>
                                </tr>
                                <tr>
                                    <td  className='td1'>4등</td>
                                    <td  className='td1'>파이어퀘스트 1개, 상장, 메달</td>
                                </tr>
                               
                                </table>

                                <p style={{marginBottom:30}}>
                            ※ 결승 진출자 전원 선수 티셔츠 제공
                        </p>

                        
                        <p style={{marginBottom:10}}>
                            <strong>· 경기 진행 세부 사항</strong>
                            </p>
                        
                        <p style={{marginBottom:10}}>
                            　- 예선경기는 6라운드 스위스 시스템으로 진행합니다.
                        </p>
                        <p style={{marginBottom:10}}>
                            　- 첫 라운드는 무작위로 선수를 매칭하여 경기를 진행합니다.
                        </p>
                        <p style={{marginBottom:10}}>
                            　- 매 라운드 승점과 생년월일로 순위를 정리하여 1위는 2위와, 3위는 4위와 … 이렇게 순차적으로 다음 라운드를 매칭 합니다. 이 때 가능하다면 만난적 없는 선수와 매칭합니다. &#40;나이가 어릴수록 순위가 높습니다.&#41;
                        </p>
                        <p style={{marginBottom:10}}>
                            　- 6라운드를 마친 후 부전승:0.5점 / 승리:1점 / 패배:0점 으로 승점을 계산합니다.
                        </p>
                        <p style={{marginBottom:10}}>
                            　- 승점의 총 합을 기준으로 최종 순위를 결정합니다.
                        </p>
                        <p style={{marginBottom:30}}>
                            　- 전체 참가자가 홀수 일 경우, 매 라운드 추첨하여 1명의 부전승자를 결정하고 0.5점 처리합니다. &#40;이미 부전승을 치른 선수는 빼고 추첨을 진행 해 주세요.&#41;
                        </p>


                            <p style={{marginBottom:0}}>
                            <strong>· 예선 순위 결정 방법</strong>
                            </p>
                            <p style={{marginBottom:0}}>
                            　· 최종 승점이 많은 사람
                            </p>
                            <p style={{marginBottom:30}}>
                            　· 동률일경우 생년월일 상 나이가 더 어린사람이 승리합니다.
                            </p>
                            

                            <p style={{marginBottom:10}}>
                            <strong>· 예선개최지 리스트</strong>
                            </p>

                            {
                                dataList.map(m=><>
                                    <table className='table1'>
                                        <tr>
                                            <th style={{width:"80px"}}>개최지명</th>
                                            <th className='th1'>{m[0]}</th>
                                        </tr>                                
                                        <tr>
                                            <td  className='td1'>주소</td>
                                            <td  className='td2'>{m[2]}</td>
                                        </tr>
                                        <tr>
                                            <td  className='td1'>연락처</td>
                                            <td  className='td2'>{m[1]}</td>
                                        </tr>
                                        <tr>
                                            <td  className='td1'>대회날짜</td>
                                            <td  className='td2'>{m[3]} {m[4]}</td>
                                        </tr>
                                    
                                    </table>

                                    <p></p>
                                </>)
                            }

                            
                        </div>
                                      
                    </div>
                </div>

                <div className='bottom1 container container1'>
                    <div className='bottom container container1'>
                    </div>

                </div>
            </div>
        </>


    );
}

export default AQU;